import React from 'react';
import { NetworkComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import NetworkRoom from './NetworkRoom';
import NetworkRoomInlineEdit from './NetworkRoomInlineEdit';

const Network = ({ networksFilter, uiComponent }: { networksFilter?: NetworkComponentInterface['networks']; uiComponent?: NetworkComponentInterface }) => {
  const networks = useSelector((state) => state.common.networks);
  const forceDisplay = networksFilter?.reduce((cv, pv) => cv + (pv.visible ? 1 : 0), 0) === 0;

  const blankNetwork = networks.find((n) => n._id === 'blank');

  return (
    <>
      <div className="flex flex-wrap gap-3.5 justify-between my-8 text-center w-full">
        {blankNetwork && <NetworkRoomInlineEdit key={blankNetwork?._id} network={blankNetwork} uiComponent={uiComponent} />}
        {networksFilter &&
          networksFilter.length > 0 &&
          networksFilter
            ?.slice()
            .sort((a, b) => a.sortIndex - b.sortIndex)
            .map((network) => {
              if (!forceDisplay && (!network.visible || networksFilter.length < 1)) return null;
              return networks.find((n) => network.networkid === n._id);
            })
            .map((network) => <>{network && <NetworkRoom key={uiComponent?._id ?? '' + network._id} network={network} uiComponent={uiComponent} />}</>)}
        {!networksFilter ||
          (networksFilter.length < 1 &&
            networks.filter((n) => n._id !== 'blank').map((network) => <NetworkRoom key={network._id} network={network} uiComponent={uiComponent} />))}
      </div>
    </>
  );
};

export default Network;
